import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked",
  "use": "checked-usage",
  "viewBox": "0 0 541.038 541.038",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 541.038 541.038\" id=\"checked\"><g><path d=\"m184.405 461.013-184.405-184.405 24.354-24.354 160.051 160.051 332.279-332.279 24.354 24.354z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"currentColor\" /></g> </symbol>"
});
var result = sprite.add(symbol);
export default symbol